// Delivery target domain types.

import type { CompanyJoin } from './company.ts';

export type DeliveryTargetRecurrence = 'none' | 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';

export const DELIVERY_TARGET_RECURRENCE_VALUES: DeliveryTargetRecurrence[] = [
  'none', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly',
];

export interface DeliveryTarget {
  id: number;
  company_id: number;
  target_weight: number;
  recurrence: DeliveryTargetRecurrence;
  estimated_weight_per_transport: number | null;
  active: boolean;
  created_at: string;
}

export interface DeliveryTargetWithCompany extends DeliveryTarget {
  company?: Pick<CompanyJoin, 'id' | 'short_name'>;
}
